import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import './App.css';
import ConnexionScreen from './ConnexionScreen.js';
import DecheteriesScreen from './DecheteriesScreen.js';
import DataSheet_localizationSheet from './DataSheet_localizationSheet.js';
import DataSheet_auth_user from './DataSheet_auth_user.js';
import DataSheet_sites from './DataSheet_sites.js';
import DataSheet_niveaux from './DataSheet_niveaux.js';
import firebase from 'firebase';
import firestore from 'firebase/firestore';


export default class App extends Component {
  constructor(props) {
    super(props);

    this.dataSheets = {};
    this.dataSheets['localizationSheet'] = new DataSheet_localizationSheet('localizationSheet', this.dataSheetDidUpdate);
    this.dataSheets['auth_user'] = new DataSheet_auth_user('auth_user', this.dataSheetDidUpdate);
    this.dataSheets['sites'] = new DataSheet_sites('sites', this.dataSheetDidUpdate);
    this.dataSheets['niveaux'] = new DataSheet_niveaux('niveaux', this.dataSheetDidUpdate);
    this.dataSheetLoaded = {};

    this.dataSlots = {};
    this.dataSlots['ds_activeLang'] = "fr";
    this.dataSlots['ds_login_screen_state'] = "0";
    this.dataSlots['ds_login_success_screen'] = "connexion";
    this.dataSlots['ds_entreprise_id'] = "null";
    this.dataSlots['ds_username'] = "";
    this.dataSlots['ds_entreprise'] = "";
    this.dataSlots['ds_admin'] = "";
    this.dataSlots['ds_rifht_forecast'] = "";
    this.dataSlots['ds_selected_site_id'] = "null";
    this.dataSlots['ds_max_ts'] = "";
    this.dataSlots['ds_site_display_name'] = "";
    this.dataSlots['ds_ouverture'] = "";
    this.dataSlots['ds_frame'] = "<iframe\nwidth=“400”\nheight=“250” \nrameborder=\"0\"\nstyle=\"border:0\"\nsrc=\"https://www.google.com/maps/embed/v1/place?key=AIzaSyBzlaY33D-BV-FLGKip83nG3xgrErZTqdM&q=Paris”\nallowfullscreen>\n</iframe>";
    this.dataSlots['ds_Slot 14'] = "";

    this.updateLocalizationFromDataSheet(this.dataSheets['localizationSheet']);


    // Initialize web service plugin 'firebase 1'
    firebase.initializeApp({
    apiKey: "AIzaSyCOmPscdkTQKyChJUcPJTDDtC56nv8Ar3k",
    authDomain: "neurowastepoint.firebaseapp.com",
    databaseURL: "https://neurowastepoint.firebaseio.com",
    projectId: "neurowastepoint",
    storageBucket: "neurowastepoint.appspot.com",
    messagingSenderId: "399083467032"
    });
    firebase.firestore().settings({});
    
    this.serviceOptions_auth_user = {
      dataSlots: this.dataSlots,
      servicePath: "users/",
      query: "where('uid', '==', '$slot('ds_userid')')",
    };
    this.dataSheets['auth_user'].firebase = firebase;
    
    this.serviceOptions_sites = {
      dataSlots: this.dataSlots,
      servicePath: "entreprises/$slot('ds_entreprise_id')/sites",
      query: "",
    };
    this.dataSheets['sites'].firebase = firebase;
    
    this.serviceOptions_niveaux = {
      dataSlots: this.dataSlots,
      servicePath: "entreprises/$slot('ds_entreprise_id')/sites/$slot('ds_selected_site_id')/points",
      query: "orderBy('ts', 'desc').limit(15)",
    };
    this.dataSheets['niveaux'].firebase = firebase;
    

    this.state = {
      currentScreen: 'connexion',
      currentScreenProps: {},
      screenTransitionForward: true,
    }
    this.screenHistory = [ {...this.state} ];

  }

  windowDidResize = () => {
    let w = window.innerWidth;
    let formatId;
    if (w < 576) formatId = 'narrow-phone';
    else if (w < 768) formatId = 'wide-phone';
    else if (w < 1024) formatId = 'narrow-tablet';
    else formatId = 'wide-tablet';
    if (formatId !== this.state.screenFormatId) {
      this.setState({screenFormatId: formatId});
    }
  }

  componentDidMount() {
    this.windowDidResize();
    window.addEventListener('resize', this.windowDidResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowDidResize);
  }

  isLoading() {
    return this.state.loading;
  }

  goToScreen = (screenId, props) => {
    // This method is the default implementation and could be customized by a navigation plugin.

    let screenIdx = -1;  // Check if the screen is already in the history stack, and pop back if so
    for (let i = 0; i < this.screenHistory.length; i++) {
      if (this.screenHistory[i].currentScreen === screenId) {
        screenIdx = i;
        break;
      }
    }
    if (screenIdx > -1) {
      this.screenHistory.splice(screenIdx + 1, this.screenHistory.length - screenIdx - 1);
      let prevScreenState = this.screenHistory[screenIdx];
      this.setState({...prevScreenState, screenTransitionForward: false});
    }
    else {
      props = props || {};
      let screenState = {currentScreen: screenId, currentScreenProps: props};
      this.screenHistory.push(screenState);
      this.setState({...screenState, screenTransitionForward: true});
    }
    window.scrollTo(0, 0);
  }

  goBack = () => {
    // This method is the default implementation and could be customized by a navigation plugin.
    if (this.screenHistory.length < 2)
      return;

    this.screenHistory.splice(this.screenHistory.length - 1, 1);
    let prevScreenState = this.screenHistory[this.screenHistory.length - 1];
    this.setState({...prevScreenState, screenTransitionForward: false});
    window.scrollTo(0, 0);
  }

  getDataSheet = (sheetId) => {
    // This method is the default implementation and could be customized by a state management plugin.
    return this.dataSheets[sheetId];
  }

  addToDataSheet = (sheetId, newRow, actionId) => {
    // This method is the default implementation and could be customized by a state management plugin.
    let sheet = this.dataSheets[sheetId];
    if (sheet && newRow) {
      sheet.addItem(newRow, this['serviceOptions_'+sheetId] || {});
    }
    this.setState({});
  }

  updateInDataSheet = (sheetId, row, actionId) => {
    // This method is the default implementation and could be customized by a state management plugin.
    let sheet = this.dataSheets[sheetId];
    if (sheet && row) {
      sheet.replaceItemByKey(row.key, row, this['serviceOptions_'+sheetId] || {});

      if (this.state.currentScreenProps.dataSheetRow) {
        let screenProps = {...this.state.currentScreenProps};
        screenProps.dataSheetRow = row;

        // Also update any props that were carried into a detail view
        for (let prop in screenProps) {
          if (row[prop] !== undefined) {
            screenProps[prop] = row[prop];
          }
        }
        this.setState({currentScreenProps: screenProps});
      } else {
        this.setState({});
      }
    }
  }

  removeFromDataSheet = (sheetId, row) => {
    let sheet = this.dataSheets[sheetId];
    if (sheet && row) {
      sheet.removeItem(row, this['serviceOptions_'+sheetId] || {});
    }
    this.setState({});
  }

  updateDataSlot = (slotId, value, actionId) => {
    // This method is the default implementation and could be customized by a state management plugin.
    this.dataSlots[slotId] = value;
    if (slotId === 'ds_activeLang') {
      this.locStrings.setLanguage(value);
    }

    if (this.serviceOptions_auth_user.query.length > 0) {
      let usedSlots = [];
      this.dataSheets['auth_user'].expandSlotTemplateString(this.serviceOptions_auth_user.query, {}, usedSlots);
      if (usedSlots.includes(slotId)) {
        // if data sheet's content depends on this slot, reload it now
        this.loadData_firebase1(this.dataSheets['auth_user'], this.serviceOptions_auth_user, true);
      }
    }
    
    {
      let usedSlots = [];
      let servicePath = this.dataSheets['auth_user'].expandSlotTemplateString("users/", this.dataSlots, usedSlots);
      if (usedSlots.includes(slotId)) {
        // if data sheet's content depends on this slot, reload it now
        this.serviceOptions_auth_user.servicePath = servicePath;
        this.loadData_firebase1(this.dataSheets['auth_user'], this.serviceOptions_auth_user, true);
      }
    }
    {
      let usedSlots = [];
      let servicePath = this.dataSheets['sites'].expandSlotTemplateString("entreprises/$slot('ds_entreprise_id')/sites", this.dataSlots, usedSlots);
      if (usedSlots.includes(slotId)) {
        // if data sheet's content depends on this slot, reload it now
        this.serviceOptions_sites.servicePath = servicePath;
        this.loadData_firebase1(this.dataSheets['sites'], this.serviceOptions_sites, true);
      }
    }
    if (this.serviceOptions_niveaux.query.length > 0) {
      let usedSlots = [];
      this.dataSheets['niveaux'].expandSlotTemplateString(this.serviceOptions_niveaux.query, {}, usedSlots);
      if (usedSlots.includes(slotId)) {
        // if data sheet's content depends on this slot, reload it now
        this.loadData_firebase1(this.dataSheets['niveaux'], this.serviceOptions_niveaux, true);
      }
    }
    
    {
      let usedSlots = [];
      let servicePath = this.dataSheets['niveaux'].expandSlotTemplateString("entreprises/$slot('ds_entreprise_id')/sites/$slot('ds_selected_site_id')/points", this.dataSlots, usedSlots);
      if (usedSlots.includes(slotId)) {
        // if data sheet's content depends on this slot, reload it now
        this.serviceOptions_niveaux.servicePath = servicePath;
        this.loadData_firebase1(this.dataSheets['niveaux'], this.serviceOptions_niveaux, true);
      }
    }
    this.setState({});
  }

  dataSheetDidUpdate = (dataSheet) => {
    // This method is the default implementation and could be customized by a state management plugin.
    this.setState({});
  }

  updateLocalizationFromDataSheet = (dataSheet) => {
    const stringsObj = dataSheet.getStringsByLanguage();
    if (stringsObj && Object.keys(stringsObj).length > 0) {
      this.locStrings = new LocalizedStrings(stringsObj);
    } else {
      this.locStrings = new LocalizedStrings({en: {}});
    }
    this.locStrings.setLanguage(this.dataSlots['ds_activeLang']);
  }

  loadData_firebase1 = (dataSheet, options, firstLoad) => {
    // This method was written by data plugin 'Firebase (Cloud Firestore)'.
    this.setState({loading: true});
    
    // clear any placeholder data before load
    if (firstLoad) {
      dataSheet.items = [];
    }
    
    const fetchComplete = (err) => {
      if (err) {
        // This error handling comes from React Studio
        // and currently doesn't do anything useful.
        console.error('** Web service load failed: ', err);
      } else {
      }
      this.setState({loading: false});
    }
    
    const db = firebase.firestore();
    let isCollectionGroup = options.servicePath.startsWith("group:");
    const collection = (isCollectionGroup) ? db.collectionGroup(options.servicePath.substring(6)) : db.collection(options.servicePath);
    const query = dataSheet.expandSlotTemplateString(options.query, this.dataSlots);
    let queryObj;
    
    if (query.length < 1) {
      queryObj = collection;
    } else {
      console.log("loading firebase data for '%s' with query: %s", options.servicePath, query);
      try {
        queryObj = eval(`(function(c){ return c.${query}; })(collection)`);
      } catch (e) {
        console.log("** error creating firebase query object from '%s': ", query, e)
        return;
      }
    }
    
    queryObj.onSnapshot(
      (querySnapshot) => {
        let jsonArr = [];
        
        if (querySnapshot.docs) {
          querySnapshot.forEach((doc) => {
            const data = { ...doc.data(), document_key: doc.id, document_ref: doc.ref };
            // const data = { ...doc.data(), document_key: doc.id };
            jsonArr.push(data);
          });
        } else if (querySnapshot.data) {
          const doc = querySnapshot;
          const data = { ...doc.data(), document_key: doc.id, document_ref: doc.ref };
          // const data = { ...doc.data(), document_key: doc.id };
          jsonArr.push(data);
        }    
            
        dataSheet.loadFromJson(jsonArr);
        fetchComplete(null, options);  
        console.log(dataSheet.id);
        if (dataSheet.id == 'group_specifiques') { console.log('lalalalalalala'); console.log(dataSheet); }
      },
      (err) => {
        fetchComplete(err, options);
      });  
    
    
     /*
    dbLoadingPromise.get().then((querySnapshot) => {
        let jsonArr = [];
    
        querySnapshot.forEach((doc) => {
          const data = { ...doc.data(), key: doc.id };
          jsonArr.push(data);
        });
            
        dataSheet.loadFromJson(jsonArr);
        fetchComplete(null, options);
      },
      (err) => {
        fetchComplete(err, options);
      });  
      */
    
  }

  render() {
    let makeElementForScreen = (screenId, baseProps, atTop, forward) => {
      let screenProps = {
        ...baseProps,
        atTopOfScreenStack: atTop,
        transitionForward: forward,
        appActions: this,
        dataSheets: this.dataSheets,
        locStrings: this.locStrings,
        deviceInfo: {
          screenFormatId: this.state.screenFormatId
        },
        'ds_activeLang': this.dataSlots['ds_activeLang'],
        'ds_login_screen_state': this.dataSlots['ds_login_screen_state'],
        'ds_login_success_screen': this.dataSlots['ds_login_success_screen'],
        'ds_entreprise_id': this.dataSlots['ds_entreprise_id'],
        'ds_username': this.dataSlots['ds_username'],
        'ds_entreprise': this.dataSlots['ds_entreprise'],
        'ds_admin': this.dataSlots['ds_admin'],
        'ds_rifht_forecast': this.dataSlots['ds_rifht_forecast'],
        'ds_selected_site_id': this.dataSlots['ds_selected_site_id'],
        'ds_max_ts': this.dataSlots['ds_max_ts'],
        'ds_site_display_name': this.dataSlots['ds_site_display_name'],
        'ds_ouverture': this.dataSlots['ds_ouverture'],
        'ds_frame': this.dataSlots['ds_frame'],
        'ds_Slot 14': this.dataSlots['ds_Slot 14'],
      };
      // A data sheet row was specified as the data source for this screen, so carry those props + 'dataSheetRow'.
      const dataSheetRow_ConnexionScreen = this.dataSheets['auth_user'].items[0];
      const screenData_ConnexionScreen = {
        ...dataSheetRow_ConnexionScreen,
        dataSheetRow: dataSheetRow_ConnexionScreen,
      }
      switch (screenId) {
        default:
          return null;
        case 'connexion':
          return (<ConnexionScreen {...screenProps} {...screenData_ConnexionScreen} />)
        case 'decheteries':
          return (<DecheteriesScreen {...screenProps} />)
      }
    }

    let screenEl = makeElementForScreen(this.state.currentScreen, this.state.currentScreenProps, true, this.state.screenTransitionForward);
    let prevScreenEl = null;
    if (this.screenHistory.length >= 2) {  // For transitions, we want to show the previous screen below
      let prevScreenState = this.screenHistory[this.screenHistory.length - 2];
      prevScreenEl = makeElementForScreen(prevScreenState.currentScreen, prevScreenState.currentScreenProps, false, this.state.screenTransitionForward);
    }

    return (
      <div className="App">
        {prevScreenEl}
        {screenEl}
      </div>
    );
  }
}
